/**
 * @generated SignedSource<<42fe5a628ea37988ba9a148314e54536>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignMainOutputFiles_urls$data = {
  readonly mainOutputFilesUrls: ReadonlyArray<{
    readonly areaID: number;
    readonly column: number | null;
    readonly format: string | null;
    readonly isPreview: boolean;
    readonly modificationID: any | null;
    readonly row: number | null;
    readonly sideID: number;
    readonly sideName: string | null;
    readonly url: string | null;
  }>;
  readonly model: {
    readonly colors: ReadonlyArray<{
      readonly sides: ReadonlyArray<{
        readonly areas: ReadonlyArray<{
          readonly areaID: number;
          readonly name: string;
        }>;
        readonly sideID: number;
      }>;
    }>;
    readonly id: string;
  };
  readonly modifications: ReadonlyArray<{
    readonly modificationID: any;
    readonly variantNotMatched: boolean;
  } | null> | null;
  readonly " $fragmentType": "DesignMainOutputFiles_urls";
};
export type DesignMainOutputFiles_urls$key = {
  readonly " $data"?: DesignMainOutputFiles_urls$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignMainOutputFiles_urls">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sideID",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "areaID",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modificationID",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignMainOutputFiles_urls",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignFile",
      "kind": "LinkedField",
      "name": "mainOutputFilesUrls",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sideName",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "format",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "row",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "column",
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPreview",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Modification",
      "kind": "LinkedField",
      "name": "modifications",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "variantNotMatched",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Model",
      "kind": "LinkedField",
      "name": "model",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Color",
          "kind": "LinkedField",
          "name": "colors",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Side",
              "kind": "LinkedField",
              "name": "sides",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Area",
                  "kind": "LinkedField",
                  "name": "areas",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Design",
  "abstractKey": null
};
})();

(node as any).hash = "8cdf10d665ed6c5742ce09f84b9525ec";

export default node;
